/* eslint-disable max-len */
export const HealthWellness = (props: Record<string, any>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden={true}
        role="img"
        {...props}
    >
        <path d="M16.7208 6.7942C16.7208 6.50167 16.6046 6.22112 16.3978 6.01428C16.1909 5.80743 15.9104 5.69122 15.6179 5.69122H12.3089V2.38228C12.3089 2.08975 12.1927 1.8092 11.9859 1.60235C11.779 1.3955 11.4985 1.2793 11.2059 1.2793H6.79402C6.50149 1.2793 6.22094 1.3955 6.01409 1.60235C5.80724 1.8092 5.69104 2.08975 5.69104 2.38228V5.69122H2.38209C2.08957 5.69122 1.80902 5.80743 1.60217 6.01428C1.39532 6.22112 1.27911 6.50167 1.27911 6.7942V11.2061C1.27911 11.4987 1.39532 11.7792 1.60217 11.986C1.80902 12.1929 2.08957 12.3091 2.38209 12.3091H5.69104V15.618C5.69104 15.9106 5.80724 16.1911 6.01409 16.398C6.22094 16.6048 6.50149 16.721 6.79402 16.721H11.2059C11.4985 16.721 11.779 16.6048 11.9859 16.398C12.1927 16.1911 12.3089 15.9106 12.3089 15.618V12.3091H15.6179C15.9104 12.3091 16.1909 12.1929 16.3978 11.986C16.6046 11.7792 16.7208 11.4987 16.7208 11.2061V6.7942Z" fill="#AEE2F7" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
HealthWellness.displayName = "HealthWellness";
